import { render } from "./SkeletonSearchFormItem.vue?vue&type=template&id=0667df91"
import script from "./SkeletonSearchFormItem.vue?vue&type=script&lang=js"
export * from "./SkeletonSearchFormItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__